import { SortInterface } from '../interfaces/ImportHistory';
import { AdvancedOptions } from '../interfaces/Mapping';
import { ImportTemplatesResponse, Template } from '../interfaces/Templates';
import { INITIAL_SORT_COLUMN_ASC } from '../shared/constants/constants';
import { getSortByColumnName } from '../shared/helpers/savedTemplatesHelpers';
import axios, { AxiosResponse } from 'axios';

interface TemplateResponse {
	data: any;
	status: number;
	success: boolean;
}

const BATCH_PROFILES_URL = '/api/v1/batch/profiles';

export const TemplatesApi = {
	async getSavedTemplates(sortedColumn: SortInterface = INITIAL_SORT_COLUMN_ASC): Promise<Template[]> {
		return axios({
			method: 'GET',
			url: BATCH_PROFILES_URL + '/saved',
			params: {
				sortBy: getSortByColumnName(sortedColumn.id),
				order: sortedColumn.isAscending ? 'asc' : 'desc',
			},
		})
			.then(response => {
				if (response.status === 200) {
					return response.data.data;
				}
			})
			.catch(error => {
				console.error('error', error);
			});
	},

	async getGlobalTemplates(): Promise<Template[]> {
		return axios({
			method: 'GET',
			url: BATCH_PROFILES_URL + '?scope=global&page=0&perPage=100',
		})
			.then(response => {
				if (response.status === 200) {
					return response.data.data.content;
				}
			})
			.catch(error => console.log('Error: ', error));
	},

	async importTemplates(formData: FormData): Promise<ImportTemplatesResponse> {
		return axios({
			method: 'POST',
			url: BATCH_PROFILES_URL + '/import',
			data: formData,
		})
			.then(response => {
				if (response.status === 200) {
					return response.data;
				}
			})
			.catch(error => {
				console.error('error', error);
				throw error;
			});
	},

	async exportTemplates(selectedTemplatesIds: string[]): Promise<AxiosResponse> {
		return axios({
			method: 'POST',
			url: BATCH_PROFILES_URL + '/export',
			data: selectedTemplatesIds,
		})
			.then(response => {
				return response;
			})
			.catch(error => {
				console.error('error', error);
				throw error;
			});
	},

	async getAllTemplates(): Promise<Template[]> {
		return axios
			.get(BATCH_PROFILES_URL)
			.then(response => {
				return response.data.data.content;
			})
			.catch(error => {
				console.error('error', error);
				throw error;
			});
	},
	async renameTemplate(selectedTemplateId: string, newTemplateName: string): Promise<AxiosResponse> {
		return axios({
			method: 'PUT',
			url: `${BATCH_PROFILES_URL}/${selectedTemplateId}/name`,
			data: {
				name: newTemplateName,
			},
		})
			.then(response => {
				return response;
			})
			.catch(error => {
				console.error('error', error);
				throw error;
			});
	},
	async getTemplate(templateId: string): Promise<Template> {
		return axios
			.get(`${BATCH_PROFILES_URL}/${templateId}`)
			.then(response => {
				return response.data.data;
			})
			.catch(error => {
				console.error('error', error);
				throw error;
			});
	},

	async deleteTemplate(selectedTemplateId: string): Promise<AxiosResponse> {
		return axios({
			method: 'DELETE',
			url: `${BATCH_PROFILES_URL}/${selectedTemplateId}`,
		})
			.then(response => {
				return response;
			})
			.catch(error => {
				console.error('error', error);
				throw error;
			});
	},
	async createTemplate(
		defaultTemplateInfo: Template,
		advancedOptions: AdvancedOptions,
		mappingId: string
	): Promise<TemplateResponse> {
		return axios
			.post(BATCH_PROFILES_URL, {
				...defaultTemplateInfo,
				...advancedOptions,
				mappingId: mappingId,
			})
			.then(response => {
				return response.data;
			})
			.catch(error => {
				console.error('error', error);
				throw error;
			});
	},
	async updateTemplate(templateInfo: Template, ruleType: string, mappingId: string) {
		return axios
			.put(`${BATCH_PROFILES_URL}/${templateInfo.id}`, {
				...templateInfo,
				ruleType,
				mappingId,
			})
			.then(response => {
				return response.data;
			})
			.catch(error => {
				console.error('error', error);
				throw error;
			});
	},
};
